<div class="saving-message">
  <div class="spinner"></div>
  <span class="text">{{ this.data.text }}</span>
</div>
